import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { GroupListing, LeafAmendment } from './Pages';

export const LeafAmendmentRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={LeafAmendment} />
    </Fragment>
)